export interface ConsumerApplication {
    fiId?: number;
    identity?: Identity;
    address?: Address;
    contactInformation?: ContactInformation;
    identityVerification?: IdentityVerification;
    employmentAndIncome?: EmploymentAndIncome;
    additionalCardholder?: AdditionalCardholder;
    candidate?: Candidate;
    device?: Device;
    accountConversion?: AccountConversion;
}

export interface Identity {
    firstName?: string;
    middleInitial?: string;
    lastName?: string;
    suffix?: string;
    nameOnCard?: string;
    dateOfBirth?: string;
    taxId?: string;
}

export interface Address {
    streetAddress?: string;
    streetAddress2?: string;
    city?: string;
    state?: string;
    zip?: string;
    mailingAddressChecked?: boolean;
    mailingStreetAddress?: string;
    mailingStreetAddress2?: string;
    mailingCity?: string;
    mailingState?: string;
    mailingZip?: string;
}

export interface ContactInformation {
    emailAddress?: string;
    mobilePhone?: string;
    additionalPhone?: string;
}

export interface IdentityVerification {
    validIdType?: string;
    idNumber?: string;
    stateIssued?: string;
    dateIssued?: string;
    expirationDate?: string;
    usCitizen?: string;
    foreignOffice?: string;
}

export interface EmploymentAndIncome {
    primaryOccupation?: string;
    primarySourceOfIncome?: string;
    totalAnnualIncome?: string;
}

export interface AdditionalCardholder {
    firstName?: string;
    middleInitial?: string;
    lastName?: string;
    suffix?: string;
    nameOnCard?: string;
    dateOfBirth?: string;
    ssn?: string;
}

export interface Device {
    device_id?: string;
}

export interface Candidate {
    reservationCode?: string;
}

export interface AccountConversion {
    reservationCode?: string;
    consent?: boolean;
    fiId?: number;
}

export interface Pricing {
    annualFee?: string;
    balanceTransferApr?: string;
    cashAdvanceApr?: string;
    creditLine?: string;
    introductoryBalanceTransferApr?: string;
    introductoryBalanceTransferTerm?: string;
    introductoryPurchaseApr?: string;
    introductoryPurchaseTerm?: string;
    mlaFlag?: boolean;
    purchaseApr?: string;
}

export interface ConsumerApplicationResponse {
    applicationSubmissionStatus?: string;
    pricing?: Pricing;
}

export interface ConsumerApplicationState {
    isLoaded: boolean;
    consumerApplication: ConsumerApplication | undefined;
    consumerApplicationResponse: ConsumerApplicationResponse | undefined;
    error: boolean;
    isValidApplicationForm: boolean;
    processingStatus: ConsumerApplicationStatus;
}

export enum ConsumerApplicationStatus {
    NONE = 'NONE',
    STARTED = 'STARTED',
    PROCESSING = 'PROCESSING',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    NOT_ELIGIBLE = 'NOT_ELIGIBLE',
    IN_REVIEW = 'IN_REVIEW',
    UPGRADING = 'UPGRADING',
    UPGRADE_SUBMITTED = 'UPGRADE_SUBMITTED',
    DECLINE_SUBMITTED = 'DECLINE_SUBMITTED',
    UPGRADE_DECLINED = 'UPGRADE_DECLINED',
    UPGRADED = 'UPGRADED',
    ERROR = 'ERROR',
}